import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ValidatePhoneFormComponent} from './validate-phone-form.component';
import {ButtonModule} from '../button/button.module';
import {ErrorMessageModule} from '../error-message/error-message.module';
import {LoadingModule} from '../loading/loading.module';
import {FormDividerModule} from '../form-divider/form-divider.module';
import { SelectMethodCodeModule } from '../select-method-code/select-method-code.module';

@NgModule({
  declarations: [ValidatePhoneFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    ErrorMessageModule,
    LoadingModule,
    FormDividerModule,
    SelectMethodCodeModule
  ],
  exports: [ValidatePhoneFormComponent],
})
export class ValidatePhoneFormModule { }
